import { useEffect, useState } from "react";
import { _LoanLine, _MessageTemplate } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { error } from "console";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const CC003 = ({ configProcedure }: Props) => {

    const { instance, setBean, bean } = useDataBean(_MessageTemplate);
    const [props, setProps] = useState<any>({});

    const acc = _single.getAffiliate();

    useEffect(() => {
        instance.getMessageTemplateCatalogPorPropiedad("CodeMessage", acc.CiudadResidenciaIDLn === 37005 ? "DOWNLOADCRED" : "DOWNLOADCREDOUTBOGO", null).then(
            (resp) => {
                if (resp.length > 0) {
                    setBean(resp[0].DataBeanProperties)
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }, [])

    useEffect(() => {
        setProps(configProcedure._pocessData.Props);
    }, [configProcedure]);

    const onExportMap = (response: any) => {
        console.log(response)
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo("Se visualizar los Documentos correctamente")
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ Obs: "Se descargaron los Documentos" })
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <span dangerouslySetInnerHTML={{ __html: bean.MessageBody ?? "" }} />
            </div>
            <div className="col-md-12">
                <hr />
            </div>
            <div className="col-md-6">
                <p>Descargar Libranza 1</p>
                <a href="./document/libranza1.pdf" target="_blank" rel="noopener noreferrer">
                    Descargar
                </a>
            </div>
            <div className="col-md-6">
                <p>Descargar Libranza 2</p>
                <a href="./document/libranza2.pdf" target="_blank" rel="noopener noreferrer">
                    Descargar
                </a>
            </div>
            <div className="col-md-6 mt-3">
                <p>Descargar Libranza 3</p>
                <a href="./document/libranza3.pdf" target="_blank" rel="noopener noreferrer">
                    Descargar
                </a>
            </div>
            <div className="col-md-12 mt-2">
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line">
                    Continuar
                </BasicButton>
            </div>
        </div>
    )

}